$(document).ready(function(){
	/* Initialize Isotope Grid */
	var $grid = $('.grid').isotope({
		itemSelector: '.grid-item',
		percentPosition: true,
		masonry: {
			columnWidth: '.grid-sizer',
			gutter: 0
		}
	});
	$grid.imagesLoaded().progress( function() {
		$grid.isotope('layout');
	});
	$('.filter-button-group').on( 'click', 'button', function() {
		var filterValue = $(this).attr('data-filter');
		$grid.isotope({ filter: filterValue });
	});
	$('button#partners-toggle').click(function(){
		$('div.about-us-partners').slideToggle();
	});
	/* Initialize sliders. */
	// $( "#client-feature-slider" ).cycle({
	// 	fx: "fade",
	// 	slides: "> img",
	// 	timeout: 5000,
	// 	speed: 200,
	// });
});
